(function () {
  'use strict';

  function getDescription(variantId) {
    const span = document.querySelector(
      '#variant-descriptions-data [data-variant-id="' + variantId + '"]'
    );
    return span ? span.dataset.description : null;
  }

  function updateDescription(variantId) {
    const el = document.getElementById('variant-description');
    if (!el || !variantId) return;
    const raw = getDescription(variantId);
    if (raw === null) return;
    el.innerHTML = raw
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\n/g, '<br>');
  }

  function getSelectedVariantId() {
    const input = document.querySelector(
      'variant-picker input[type="radio"][data-current-checked="true"]'
    );
    if (input) return input.dataset.variantId;

    const match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  function init() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    picker.addEventListener('change', function () {
      setTimeout(function () {
        const variantId = getSelectedVariantId();
        if (variantId) updateDescription(variantId);
      }, 100);
    });

    const variantId = getSelectedVariantId();
    if (variantId) updateDescription(variantId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();